module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Clothes/Hanger-fd5d152e16f6dc717a1606a86b21287b.svg";